module.exports = __webpack_public_path__ + "assets/c4b6896afa8678ba000b7233f6ee5eed.png";